// src/components/ui/AlertRow.jsx — v8.7.1 PATCHED
// FIX: timestamp autodetect ms vs sec
// alerts_history пишет Date.now() = миллисекунды

import AlertBadge from "./AlertBadge";

function parseTs(ts) {
  if (!ts) return null;
  const n = Number(ts);
  return n > 1e12 ? new Date(n) : new Date(n * 1000);
}

export default function AlertRow({ item }) {
  if (!item) return null;

  const level   = (item.level ?? item.severity ?? item.type ?? "info").toLowerCase();
  const message = item.message ?? item.alert_type ?? item.title ?? "Alert";
  const dateObj = parseTs(item.timestamp);
  const ts      = dateObj
    ? dateObj.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

  const levelColors = {
    critical: "var(--danger)",
    high:     "var(--danger)",
    warning:  "var(--warning)",
    medium:   "var(--warning)",
    info:     "var(--accent-primary)",
    low:      "var(--text-muted)",
  };
  const labelColor = levelColors[level] ?? levelColors.info;

  return (
    <div style={{
      display: "flex", alignItems: "center",
      justifyContent: "space-between",
      padding: "12px 20px", gap: 16,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 0 }}>
        <AlertBadge status={level} />
        <span style={{
          fontSize: 13, color: "var(--text-primary)",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }}>
          {message}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
        <span style={{
          fontFamily: "var(--font-mono)", fontSize: 10,
          color: "var(--text-muted)", whiteSpace: "nowrap",
        }}>
          {ts}
        </span>
        <span style={{
          padding: "2px 8px", borderRadius: "var(--radius-sm)",
          border: `1px solid ${labelColor}40`,
          background: `${labelColor}10`,
          fontFamily: "var(--font-mono)", fontSize: 9,
          fontWeight: 700, letterSpacing: "0.1em",
          color: labelColor, textTransform: "uppercase",
        }}>
          {level}
        </span>
      </div>
    </div>
  );
}
